<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      2. {{ $t('common_words.verify_inputed_information') }}
    </p>
    <div class="row d-flex justify-content-center">
      <div class="col-10">
        <table class="table">
          <tbody>
            <tr class="shadow-sm">
              <td>
                <strong>{{ $t('common_words.company') }}:</strong>
                {{ infoData.business_name }}
              </td>
              <td>
                <strong>{{ $t('common_words.farm') }}:</strong>
                {{ infoData.farm_name }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-for="(_, index) in infoData.names"
          :key="index"
          class="row border rounded-sm shadow-sm p-3 mb-3"
        >
          <div class="col-4">
            <strong>{{ $t('common_words.valve') }}:</strong>
            {{ infoData.valve_names[index] }}
          </div>
          <div class="col-4">
            <strong>{{ $t('common_words.depth') }}:</strong>
            {{ infoData.depths[index] }}
          </div>
          <div class="col-4">
            <strong>{{ $t('common_words.name') }}:</strong>
            {{ infoData.names[index] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blood-pressure-monitors-step-confirm',
  props: {
    infoData: { type: Object, required: true },
  },
};
</script>
